



/**
 * @typedef {"TOGGLE_TAB" | "GET_PROFILE" | "SET_STATE" | "SET_TOAST" | "TOGGLE_IMAGE_VIEWER"} ActionName
 */



export default {
    TOGGLETAB:"TOGGLE_TAB",
    UPDAEFORM:"UPDATE_FORM",
    GETPROFILE:"GET_PROFILE",
    SETSTATE:"SET_STATE",
    SETTOST:"SET_TOAST",
    TOGGLE_IMAGE_VIEWER:"TOGGLE_IMAGE_VIEWER"
}